export enum TransactionBalanceName {
  CASH_BALANCE = 'Fluz Cash Balance',
  PREPAYMENT_BALANCE = 'Fluz prepayment balance',
  REWARDS_BALANCE = 'Rewards balance',
}

export enum TransactionInternalAccountType {
  All = 'all-balances',
  REWARDS_AND_PREPAYMENT_BALANCE = 'rewards-and-prepayment',
  REWARDS_BALANCE = 'rewards',
  PREPAYMENT_BALANCE = 'prepayment',
  CASH_BALANCE = 'spend-accounts',
}

export const TransactionBalanceTypeNameMap: Partial<
  Record<TransactionInternalAccountType, TransactionBalanceName | string>
> = {
  [TransactionInternalAccountType.CASH_BALANCE]: 'Spend accounts',
  [TransactionInternalAccountType.PREPAYMENT_BALANCE]: TransactionBalanceName.PREPAYMENT_BALANCE,
  [TransactionInternalAccountType.REWARDS_BALANCE]: TransactionBalanceName.REWARDS_BALANCE,
};
